import axios from 'axios';
import authHeader from "@/service/auth-header";

class ProspectService {

    async getCompanyProspects(companyId) {
        return await axios.get(`/api/prospect/${companyId}`, {headers: authHeader()})
    }

    async getUserProspects(userId) {
        return await axios.get(`/api/prospect/user/${userId}`, {headers: authHeader()})
    }

    async getProspect(prospectId) {
        return await axios.get(`/api/prospect/specific/${prospectId}`, {headers: authHeader()})
    }

    async createProspect(companyId, data) {
        return await axios.post(`/api/prospect/${companyId}`, data, {headers: authHeader()});
    }

    async createExternalProspect(companyId, data) {
        return await axios.post(`/api/prospect/external/${companyId}`, data);
    }

    async updateProspect(prospectId, data) {
        return await axios.put(`/api/prospect/${prospectId}`, data, {headers: authHeader()});
    }

    async deleteProspect(prospectId) {
        return await axios.delete(`/api/prospect/${prospectId}`, {headers: authHeader()})
    }

    async completeProspect(prospectId) {
        console.log("[ProspectService][completeProspect] Before making REST call. Prospect ID = ", prospectId);

        return await axios.post(`/api/prospect/complete/${prospectId}`,null, {headers: authHeader()})
    }

    async sendEmail(prospectId, data) {
        return await axios.post(`/api/prospect/email/${prospectId}`, data, {headers: authHeader()});
    }

    async sendSms(prospectId, data) {
        return await axios.post(`/api/prospect/sms/${prospectId}`, data, {headers: authHeader()});
    }

    async updateAuditTrail(prospectId, data) {
        return await axios.post(`/api/prospect/audittrail/${prospectId}`, data, {headers: authHeader()});
    }

}

export default new ProspectService();
